<div class="flex flex-col h-full bg-white">
    <div class="row justify-between card-header px-4 py-3 border-b">
        <div class="text-[15px] font-medium tracking-tight truncate m-0">
            Well Healthiness Percentage
        </div>
    </div>
    <div class="flex-auto flex items-center justify-center p-4">
        <div id="chartdiv" class="w-full h-[400px] min-h-[400px]"></div>
    </div>
</div>
